import { cdnHost, s3ImagesCdnEndpoint, s3ImagesEndpoint, bugsnagApiKey } from '../../config';
import { getCatalogueProductList, getCompanyId, getProduct, shouldLoadCloudfront } from './Amalgam';
import { geocodePincode as apiGeocodePincode } from './Api';
import { getCountries } from './Country';
import cache from './cache';
import { route } from 'preact-router';
import { getShowcaseSlug } from './Showcase';
import * as queryString from './QueryString';
import { getCatalogueTheme } from './Theme';
import { deleteLocalStorage, getLocalStorage, putLocalStorage } from './LocalStorage';
import { includes } from '../../../utils/GlobalUtils';

export const MORE_PRODUCTS_TITLE = 'More products';
export const MORE_PRODUCTS_COUNT = 20;
export const MORE_CATALOGUES_COUNT = 20;
export const MORE_PRODUCTS_BASED_ON_TAG_COUNT = 10;
export const MORE_PRODUCTS_BASED_ON_TAG_PAGE_START = 3;
export const RETURN_URI = 'returnUri';
export const VIEW_OFFERS_HASH = '#view-offers';
export const SIZE_GUIDE_HASH = '#size-guide';
export const SEARCH_TERM = 'searchTerm';
export const SOURCE_HOMEPAGE = 'Homepage';
export const QUICKSELL_WHATSAPP = '19379155571';
const SAVED_SCROLLED_POSITIONS_KEY = 'SAVED_SCROLLED_POSITIONS_QS_CATALOGUE_APP';

export const URL_REGEX = /^(www\.|http[s]?:\/\/)\S+$/g;
export const STARTS_WITH_WWW = /^www\.\S+$/g;
export const CUSTOM_PAGE_SHOW_CONTENT_MOBILE = 4;
export const CUSTOM_PAGE_SHOW_CONTENT_DESKTOP = 10;
export const CUSTOM_PAGE_CATALOGUE_TILES_PER_ROW_DEFAULT = 4;

export const DEFAULT_FONT_FAMILY = "'Helvetica Neue', 'Roboto', sans-serif";

export const HTML_TYPES = {
  IFRAME: 'IFRAME',
  SHADOW_DOM: 'SHADOW_DOM',
  INNER_HTML: 'INNER_HTML'
};

export const FONT_TYPES = {
  DEFAULT: 'DEFAULT',
  HEADING: 'HEADING',
  SUB_HEADING: 'SUB_HEADING',
  PARAGRAPH: 'PARAGRAPH'
};

export const SCREEN_TYPES = {
  DESKTOP: 'desktop',
  MOBILE: 'mobile'
};

export const HOME_LAYOUT_VIEW = {
  LIST: 'list',
  LIST_VIEW: 'list-view'
};

export const HOME_LAYOUT_TYPE = {
  GRID: 'GRID',
  MAGAZINE: 'MAGAZINE',
  LIST: 'LIST'
};

export const BUNDLE_VIEW = {
  RESELLER: 'RESELLER'
};

export const CHUNK_VIEW = {
  RESELLER: 'resellerview',
  RESELL_SINGLE_CATALOGUE: 'resell-single',
  SINGLE_CATALOGUE: 'single',
  GALLERY_PAGE: 'gallery',
  IMAGE_PAGE: 'image',
  GROUP_CATALOGUE: 'group',
  CUSTOM_PAGE: 'custompage',
  COMPANY_DETAIL: 'company-detail',
  CUSTOMER_ORDERS: 'customer-orders',
  GLOBAL_REVIEW: 'global-review'
};

export const RESELLER_TABS = {
  CATALOGUE: 0,
  ORDER: 1
};

export const SCROLL_POS_KEYS = {
  REVIEW_PAGE: 'reviewScroll'
};

export const ORDER_FROM = {
  RESELLER: 'RESELLER'
};

export const galleryPictureThumbsWidth = 75;

export const MEDIA_TYPES = {
  IMAGE: 'IMAGE',
  VIDEO: 'VIDEO'
};

export const SECTION_TYPES = {
  PRODUCT: 'product',
  CATALOGUE: 'catalogue',
  CATEGORIES: 'categories',
  BANNER: 'banner',
  TEXT: 'text',
  HTML: 'html'
};

export const SOCIAL_LINK_SLUGS = {
  FACEBOOK: 'facebook',
  INSTAGRAM: 'instagram',
  YOUTUBE: 'youtube',
  TWITTER: 'twitter'
};

export const SOCIAL_LINK_TYPES = {
  FACEBOOK: 'FACEBOOK',
  INSTAGRAM: 'INSTAGRAM',
  YOUTUBE: 'YOUTUBE',
  TWITTER: 'TWITTER'
};

export const COMPANY_DETAILS_PAGE_SLUGS = {
  ABOUT_US: 'about-us',
  PRIVACY_POLICY: 'privacy-policy',
  TERMS_AND_CONDITIONS: 'terms-and-conditions',
  REFUND_AND_EXCHANGE_POLICY: 'refund-and-exchange-policy'
};

export const ENTITY_BASE = {
  METAL: 'METAL',
  STONE: 'STONE',
  WASTAGE_CHARGE: 'WASTAGE_CHARGE',
  MAKING_CHARGE: 'MAKING_CHARGE'
};

export const CUSTOM_COMPONENT_TYPES = {
  PRODUCT_GRID_TILE: 'PRODUCT_GRID_TILE',
  PRODUCT_LIST_TILE: 'PRODUCT_LIST_TILE',
  PRODUCT_MAGAZINE: 'PRODUCT_MAGAZINE',
  CATALOGUE_GRID_TILE: 'CATALOGUE_GRID_TILE'
};

export const PRODUCT_GRID_TILE_CUSTOM_COMPONENT_PREFIX = 'product-grid-tile';

export const PRODUCT_LIST_TILE_CUSTOM_COMPONENT_PREFIX = 'product-list-tile';

export const PRODUCT_MAGAZINE_TILE_CUSTOM_COMPONENT_PREFIX = 'product-magazine-tile';

export const CATALOGUE_GRID_TILE_CUSTOM_COMPONENT_PREFIX = 'catalogue-grid-tile';

export const PRODUCT_GRID_TILE_CUSTOM_COMPONENT_VARIABLES = {
  PICTURE_ID: '{{pictureId}}',
  PICTURE_URL: '{{pictureUrl}}',
  PICTURE_ALT: '{{pictureAlt}}',
  PICTURE_HEIGHT: '{{pictureHeight}}',
  PICTURE_WIDTH: '{{pictureWidth}}',
  DISCOUNT_PERCENT: '{{discountPercent}}',
  OUT_OF_STOCK_TEXT: '{{outOfStockText}}',
  PICTURE_COUNT: '{{pictureCount}}',
  VARIANT_COLOR_COUNT: '{{variantColorCount}}',
  PRODUCT_ID: '{{productId}}',
  PRODUCT_NAME: '{{productName}}',
  PRODUCT_PRICE: '{{productPrice}}',
  PRODUCT_DISCOUNTED_PRICE: '{{productDiscountedPrice}}',
  PRODUCT_TAX_PRICE: '{{productTaxPrice}}',
  ADD_TO_CART_BUTTON_TEXT: '{{addToCartButtonText}}'
};

export const PRODUCT_LIST_TILE_CUSTOM_COMPONENT_VARIABLES = {
  PICTURE_ID: '{{pictureId}}',
  PICTURE_URL: '{{pictureUrl}}',
  PICTURE_ALT: '{{pictureAlt}}',
  PICTURE_HEIGHT: '{{pictureHeight}}',
  PICTURE_WIDTH: '{{pictureWidth}}',
  DISCOUNT_PERCENT: '{{discountPercent}}',
  OUT_OF_STOCK_TEXT: '{{outOfStockText}}',
  PICTURE_COUNT: '{{pictureCount}}',
  VARIANT_COLOR_COUNT: '{{variantColorCount}}',
  PRODUCT_ID: '{{productId}}',
  PRODUCT_NAME: '{{productName}}',
  PRODUCT_DESCRIPTION: '{{productDescription}}',
  PRODUCT_PRICE: '{{productPrice}}',
  PRODUCT_DISCOUNTED_PRICE: '{{productDiscountedPrice}}',
  PRODUCT_TAX_PRICE: '{{productTaxPrice}}',
  ADD_TO_CART_BUTTON_TEXT: '{{addToCartButtonText}}'
};

export const PRODUCT_MAGAZINE_TILE_CUSTOM_COMPONENT_VARIABLES = {
  PICTURE_ID: '{{pictureId}}',
  PICTURE_URL: '{{pictureUrl}}',
  PICTURE_ALT: '{{pictureAlt}}',
  PICTURE_HEIGHT: '{{pictureHeight}}',
  PICTURE_WIDTH: '{{pictureWidth}}',
  DISCOUNT_PERCENT: '{{discountPercent}}',
  OUT_OF_STOCK_TEXT: '{{outOfStockText}}',
  PICTURE_COUNT: '{{pictureCount}}',
  VARIANT_COLOR_COUNT: '{{variantColorCount}}',
  PRODUCT_ID: '{{productId}}',
  PRODUCT_NAME: '{{productName}}',
  PRODUCT_SKU: '{{productSku}}',
  PRODUCT_DESCRIPTION: '{{productDescription}}',
  PRODUCT_PRICE: '{{productPrice}}',
  PRODUCT_DISCOUNTED_PRICE: '{{productDiscountedPrice}}',
  PRODUCT_TAX_PRICE: '{{productTaxPrice}}',
  PRODUCT_MOQ: '{{productMinimumOrderQuantity}}',
  ADD_TO_CART_BUTTON_TEXT: '{{addToCartButtonText}}'
};

export const CATALOGUE_GRID_TILE_CUSTOM_COMPONENT_VARIABLES = {
  PICTURE_ID: '{{pictureId}}',
  PICTURE_URL: '{{pictureUrl}}',
  PICTURE_ALT: '{{pictureAlt}}',
  PICTURE_HEIGHT: '{{pictureHeight}}',
  PICTURE_WIDTH: '{{pictureWidth}}',
  CATALOGUE_ID: '{{catalogueId}}',
  CATALOGUE_TITLE: '{{catalogueTitle}}',
  PRODUCT_COUNT: '{{productCount}}'
};

export const PRODUCT_GRID_TILE_CLASSNAMES_MAP = {
  productGridTileId: `${PRODUCT_GRID_TILE_CUSTOM_COMPONENT_PREFIX}-id`,
  productGridTileContainer: `${PRODUCT_GRID_TILE_CUSTOM_COMPONENT_PREFIX}-container`,
  productGridTileImageContainer: `${PRODUCT_GRID_TILE_CUSTOM_COMPONENT_PREFIX}-image-container`,
  productGridTileDiscountBadge: `${PRODUCT_GRID_TILE_CUSTOM_COMPONENT_PREFIX}-discount-badge`,
  productGridTileOutOfStockBadge: `${PRODUCT_GRID_TILE_CUSTOM_COMPONENT_PREFIX}-out-of-stock-badge`,
  productGridTileVideoBadge: `${PRODUCT_GRID_TILE_CUSTOM_COMPONENT_PREFIX}-video-badge`,
  productGridTilePhotoCountBadge: `${PRODUCT_GRID_TILE_CUSTOM_COMPONENT_PREFIX}-photo-count-badge`,
  productGridTileImage: `${PRODUCT_GRID_TILE_CUSTOM_COMPONENT_PREFIX}-image`,
  productGridTileImageHeight: `${PRODUCT_GRID_TILE_CUSTOM_COMPONENT_PREFIX}-image-height`,
  productGridTileImageWidth: `${PRODUCT_GRID_TILE_CUSTOM_COMPONENT_PREFIX}-image-width`,
  productGridTileDetailsContainer: `${PRODUCT_GRID_TILE_CUSTOM_COMPONENT_PREFIX}-details-container`,
  productGridTileVariantDetailsContainer: `${PRODUCT_GRID_TILE_CUSTOM_COMPONENT_PREFIX}-variant-details-container`,
  productGridTileVariantColors: `${PRODUCT_GRID_TILE_CUSTOM_COMPONENT_PREFIX}-variant-colors`,
  productGridTileVariantColor: `${PRODUCT_GRID_TILE_CUSTOM_COMPONENT_PREFIX}-variant-color`,
  productGridTileVariantColorCount: `${PRODUCT_GRID_TILE_CUSTOM_COMPONENT_PREFIX}-variant-color-count`,
  productGridTileName: `${PRODUCT_GRID_TILE_CUSTOM_COMPONENT_PREFIX}-name`,
  productGridTilePriceContainer: `${PRODUCT_GRID_TILE_CUSTOM_COMPONENT_PREFIX}-price-container`,
  productGridTilePrice: `${PRODUCT_GRID_TILE_CUSTOM_COMPONENT_PREFIX}-price`,
  productGridTilePriceDiscount: `${PRODUCT_GRID_TILE_CUSTOM_COMPONENT_PREFIX}-price-discount`,
  productGridTilePriceTax: `${PRODUCT_GRID_TILE_CUSTOM_COMPONENT_PREFIX}-price-tax`,
  productGridTileAddToCartContainer: `${PRODUCT_GRID_TILE_CUSTOM_COMPONENT_PREFIX}-add-to-cart-container`,
  productGridTileAddToCartLoader: `${PRODUCT_GRID_TILE_CUSTOM_COMPONENT_PREFIX}-add-to-cart-loader`,
  productGridTileAddToCartLoaderSvg: `${PRODUCT_GRID_TILE_CUSTOM_COMPONENT_PREFIX}-add-to-cart-loader-svg`,
  productGridTileAddToCart: `${PRODUCT_GRID_TILE_CUSTOM_COMPONENT_PREFIX}-add-to-cart`,
  productGridTileInquiryContainer: `${PRODUCT_GRID_TILE_CUSTOM_COMPONENT_PREFIX}-inquiry-container`,
  productGridTileInquiryMinus: `${PRODUCT_GRID_TILE_CUSTOM_COMPONENT_PREFIX}-inquiry-minus`,
  productGridTileInquiryMinusText: `${PRODUCT_GRID_TILE_CUSTOM_COMPONENT_PREFIX}-inquiry-minus-text`,
  productGridTileInquiryCount: `${PRODUCT_GRID_TILE_CUSTOM_COMPONENT_PREFIX}-inquiry-count`,
  productGridTileInquiryCountText: `${PRODUCT_GRID_TILE_CUSTOM_COMPONENT_PREFIX}-inquiry-count-text`,
  productGridTileInquiryPlus: `${PRODUCT_GRID_TILE_CUSTOM_COMPONENT_PREFIX}-inquiry-plus`,
  productGridTileInquiryPlusText: `${PRODUCT_GRID_TILE_CUSTOM_COMPONENT_PREFIX}-inquiry-plus-text`
};

export const PRODUCT_LIST_TILE_CLASSNAMES_MAP = {
  productListTileId: `${PRODUCT_LIST_TILE_CUSTOM_COMPONENT_PREFIX}-id`,
  productListTileContainer: `${PRODUCT_LIST_TILE_CUSTOM_COMPONENT_PREFIX}-container`,
  productListTileImageContainer: `${PRODUCT_LIST_TILE_CUSTOM_COMPONENT_PREFIX}-image-container`,
  productListTileDiscountBadge: `${PRODUCT_LIST_TILE_CUSTOM_COMPONENT_PREFIX}-discount-badge`,
  productListTileOutOfStockBadge: `${PRODUCT_LIST_TILE_CUSTOM_COMPONENT_PREFIX}-out-of-stock-badge`,
  productListTileVideoBadge: `${PRODUCT_LIST_TILE_CUSTOM_COMPONENT_PREFIX}-video-badge`,
  productListTilePhotoCountBadge: `${PRODUCT_LIST_TILE_CUSTOM_COMPONENT_PREFIX}-photo-count-badge`,
  productListTileImage: `${PRODUCT_LIST_TILE_CUSTOM_COMPONENT_PREFIX}-image`,
  productListTileImageHeight: `${PRODUCT_LIST_TILE_CUSTOM_COMPONENT_PREFIX}-image-height`,
  productListTileImageWidth: `${PRODUCT_LIST_TILE_CUSTOM_COMPONENT_PREFIX}-image-width`,
  productListTileDetailsContainer: `${PRODUCT_LIST_TILE_CUSTOM_COMPONENT_PREFIX}-details-container`,
  productListTileVariantDetailsContainer: `${PRODUCT_LIST_TILE_CUSTOM_COMPONENT_PREFIX}-variant-details-container`,
  productListTileVariantColors: `${PRODUCT_LIST_TILE_CUSTOM_COMPONENT_PREFIX}-variant-colors`,
  productListTileVariantColor: `${PRODUCT_LIST_TILE_CUSTOM_COMPONENT_PREFIX}-variant-color`,
  productListTileVariantColorCount: `${PRODUCT_LIST_TILE_CUSTOM_COMPONENT_PREFIX}-variant-color-count`,
  productListTileName: `${PRODUCT_LIST_TILE_CUSTOM_COMPONENT_PREFIX}-name`,
  productListTileDescription: `${PRODUCT_LIST_TILE_CUSTOM_COMPONENT_PREFIX}-description`,
  productListTilePriceAddToCartContainer: `${PRODUCT_LIST_TILE_CUSTOM_COMPONENT_PREFIX}-price-add-to-cart-container`,
  productListTilePriceDiscountContainer: `${PRODUCT_LIST_TILE_CUSTOM_COMPONENT_PREFIX}-price-discount-container`,
  productListTilePriceContainer: `${PRODUCT_LIST_TILE_CUSTOM_COMPONENT_PREFIX}-price-container`,
  productListTilePrice: `${PRODUCT_LIST_TILE_CUSTOM_COMPONENT_PREFIX}-price`,
  productListTilePriceDiscount: `${PRODUCT_LIST_TILE_CUSTOM_COMPONENT_PREFIX}-price-discount`,
  productListTilePriceTax: `${PRODUCT_LIST_TILE_CUSTOM_COMPONENT_PREFIX}-price-tax`,
  productListTileAddToCartContainer: `${PRODUCT_LIST_TILE_CUSTOM_COMPONENT_PREFIX}-add-to-cart-container`,
  productListTileAddToCartLoader: `${PRODUCT_LIST_TILE_CUSTOM_COMPONENT_PREFIX}-add-to-cart-loader`,
  productListTileAddToCartLoaderSvg: `${PRODUCT_LIST_TILE_CUSTOM_COMPONENT_PREFIX}-add-to-cart-loader-svg`,
  productListTileAddToCart: `${PRODUCT_LIST_TILE_CUSTOM_COMPONENT_PREFIX}-add-to-cart`,
  productListTileInquiryContainer: `${PRODUCT_LIST_TILE_CUSTOM_COMPONENT_PREFIX}-inquiry-container`,
  productListTileInquiryMinus: `${PRODUCT_LIST_TILE_CUSTOM_COMPONENT_PREFIX}-inquiry-minus`,
  productListTileInquiryMinusText: `${PRODUCT_LIST_TILE_CUSTOM_COMPONENT_PREFIX}-inquiry-minus-text`,
  productListTileInquiryCount: `${PRODUCT_LIST_TILE_CUSTOM_COMPONENT_PREFIX}-inquiry-count`,
  productListTileInquiryCountText: `${PRODUCT_LIST_TILE_CUSTOM_COMPONENT_PREFIX}-inquiry-count-text`,
  productListTileInquiryPlus: `${PRODUCT_LIST_TILE_CUSTOM_COMPONENT_PREFIX}-inquiry-plus`,
  productListTileInquiryPlusText: `${PRODUCT_LIST_TILE_CUSTOM_COMPONENT_PREFIX}-inquiry-plus-text`
};

export const PRODUCT_MAGAZINE_TILE_CLASSNAMES_MAP = {
  productMagazineTileId: `${PRODUCT_MAGAZINE_TILE_CUSTOM_COMPONENT_PREFIX}-id`,
  productMagazineTileContainer: `${PRODUCT_MAGAZINE_TILE_CUSTOM_COMPONENT_PREFIX}-container`,
  productMagazineTileImageContainer: `${PRODUCT_MAGAZINE_TILE_CUSTOM_COMPONENT_PREFIX}-image-container`,
  productMagazineTileDiscountBadge: `${PRODUCT_MAGAZINE_TILE_CUSTOM_COMPONENT_PREFIX}-discount-badge`,
  productMagazineTileOutOfStockBadge: `${PRODUCT_MAGAZINE_TILE_CUSTOM_COMPONENT_PREFIX}-out-of-stock-badge`,
  productMagazineTileVideoBadge: `${PRODUCT_MAGAZINE_TILE_CUSTOM_COMPONENT_PREFIX}-video-badge`,
  productMagazineTilePhotoCountBadge: `${PRODUCT_MAGAZINE_TILE_CUSTOM_COMPONENT_PREFIX}-photo-count-badge`,
  productMagazineTileImage: `${PRODUCT_MAGAZINE_TILE_CUSTOM_COMPONENT_PREFIX}-image`,
  productMagazineTileImagePrevious: `${PRODUCT_MAGAZINE_TILE_CUSTOM_COMPONENT_PREFIX}-image-previous`,
  productMagazineTileImageNext: `${PRODUCT_MAGAZINE_TILE_CUSTOM_COMPONENT_PREFIX}-image-next`,
  productMagazineTileImageHeight: `${PRODUCT_MAGAZINE_TILE_CUSTOM_COMPONENT_PREFIX}-image-height`,
  productMagazineTileImageWidth: `${PRODUCT_MAGAZINE_TILE_CUSTOM_COMPONENT_PREFIX}-image-width`,
  productMagazineTileDetailsContainer: `${PRODUCT_MAGAZINE_TILE_CUSTOM_COMPONENT_PREFIX}-details-container`,
  productMagazineTileThumbnailsContainer: `${PRODUCT_MAGAZINE_TILE_CUSTOM_COMPONENT_PREFIX}-thumbnails-container`,
  productMagazineTileThumbnailContainer: `${PRODUCT_MAGAZINE_TILE_CUSTOM_COMPONENT_PREFIX}-thumbnail-container`,
  productMagazineTileThumbnail: `${PRODUCT_MAGAZINE_TILE_CUSTOM_COMPONENT_PREFIX}-thumbnail`,
  productMagazineTileThumbnailId: `${PRODUCT_MAGAZINE_TILE_CUSTOM_COMPONENT_PREFIX}-thumbnail-id`,
  productMagazineTileThumbnailSelected: `${PRODUCT_MAGAZINE_TILE_CUSTOM_COMPONENT_PREFIX}-thumbnail-selected`,
  productMagazineTileVariantDetailsContainer: `${PRODUCT_MAGAZINE_TILE_CUSTOM_COMPONENT_PREFIX}-variant-details-container`,
  productMagazineTileVariantColors: `${PRODUCT_MAGAZINE_TILE_CUSTOM_COMPONENT_PREFIX}-variant-colors`,
  productMagazineTileVariantColor: `${PRODUCT_MAGAZINE_TILE_CUSTOM_COMPONENT_PREFIX}-variant-color`,
  productMagazineTileVariantColorCount: `${PRODUCT_MAGAZINE_TILE_CUSTOM_COMPONENT_PREFIX}-variant-color-count`,
  productMagazineTileName: `${PRODUCT_MAGAZINE_TILE_CUSTOM_COMPONENT_PREFIX}-name`,
  productMagazineTileSku: `${PRODUCT_MAGAZINE_TILE_CUSTOM_COMPONENT_PREFIX}-sku`,
  productMagazineTileDescription: `${PRODUCT_MAGAZINE_TILE_CUSTOM_COMPONENT_PREFIX}-description`,
  productMagazineTilePriceAddToCartContainer: `${PRODUCT_MAGAZINE_TILE_CUSTOM_COMPONENT_PREFIX}-price-add-to-cart-container`,
  productMagazineTilePriceDiscountContainer: `${PRODUCT_MAGAZINE_TILE_CUSTOM_COMPONENT_PREFIX}-price-discount-container`,
  productMagazineTilePriceContainer: `${PRODUCT_MAGAZINE_TILE_CUSTOM_COMPONENT_PREFIX}-price-container`,
  productMagazineTilePrice: `${PRODUCT_MAGAZINE_TILE_CUSTOM_COMPONENT_PREFIX}-price`,
  productMagazineTilePriceDiscount: `${PRODUCT_MAGAZINE_TILE_CUSTOM_COMPONENT_PREFIX}-price-discount`,
  productMagazineTilePriceTax: `${PRODUCT_MAGAZINE_TILE_CUSTOM_COMPONENT_PREFIX}-price-tax`,
  productMagazineTileMinimumOrderQuantity: `${PRODUCT_MAGAZINE_TILE_CUSTOM_COMPONENT_PREFIX}-minimum-order-quantity`,
  productMagazineTileAddToCartContainer: `${PRODUCT_MAGAZINE_TILE_CUSTOM_COMPONENT_PREFIX}-add-to-cart-container`,
  productMagazineTileAddToCartLoader: `${PRODUCT_MAGAZINE_TILE_CUSTOM_COMPONENT_PREFIX}-add-to-cart-loader`,
  productMagazineTileAddToCartLoaderSvg: `${PRODUCT_MAGAZINE_TILE_CUSTOM_COMPONENT_PREFIX}-add-to-cart-loader-svg`,
  productMagazineTileAddToCart: `${PRODUCT_MAGAZINE_TILE_CUSTOM_COMPONENT_PREFIX}-add-to-cart`,
  productMagazineTileInquiryContainer: `${PRODUCT_MAGAZINE_TILE_CUSTOM_COMPONENT_PREFIX}-inquiry-container`,
  productMagazineTileInquiryMinus: `${PRODUCT_MAGAZINE_TILE_CUSTOM_COMPONENT_PREFIX}-inquiry-minus`,
  productMagazineTileInquiryMinusText: `${PRODUCT_MAGAZINE_TILE_CUSTOM_COMPONENT_PREFIX}-inquiry-minus-text`,
  productMagazineTileInquiryCount: `${PRODUCT_MAGAZINE_TILE_CUSTOM_COMPONENT_PREFIX}-inquiry-count`,
  productMagazineTileInquiryCountText: `${PRODUCT_MAGAZINE_TILE_CUSTOM_COMPONENT_PREFIX}-inquiry-count-text`,
  productMagazineTileInquiryPlus: `${PRODUCT_MAGAZINE_TILE_CUSTOM_COMPONENT_PREFIX}-inquiry-plus`,
  productMagazineTileInquiryPlusText: `${PRODUCT_MAGAZINE_TILE_CUSTOM_COMPONENT_PREFIX}-inquiry-plus-text`
};

export const CATALOGUE_GRID_TILE_CLASSNAMES_MAP = {
  catalogueGridTileId: `${CATALOGUE_GRID_TILE_CUSTOM_COMPONENT_PREFIX}-id`,
  catalogueGridTileContainer: `${CATALOGUE_GRID_TILE_CUSTOM_COMPONENT_PREFIX}-container`,
  catalogueGridTileImageContainer: `${CATALOGUE_GRID_TILE_CUSTOM_COMPONENT_PREFIX}-image-container`,
  catalogueGridTileLockBadge: `${CATALOGUE_GRID_TILE_CUSTOM_COMPONENT_PREFIX}-lock-badge`,
  catalogueGridTileImage: `${CATALOGUE_GRID_TILE_CUSTOM_COMPONENT_PREFIX}-image`,
  catalogueGridTileImageHeight: `${CATALOGUE_GRID_TILE_CUSTOM_COMPONENT_PREFIX}-image-height`,
  catalogueGridTileImageWidth: `${CATALOGUE_GRID_TILE_CUSTOM_COMPONENT_PREFIX}-image-width`,
  catalogueGridTileDetailsContainer: `${CATALOGUE_GRID_TILE_CUSTOM_COMPONENT_PREFIX}-details-container`,
  catalogueGridTileLoader: `${CATALOGUE_GRID_TILE_CUSTOM_COMPONENT_PREFIX}-loader`,
  catalogueGridTileTitle: `${CATALOGUE_GRID_TILE_CUSTOM_COMPONENT_PREFIX}-title`,
  catalogueGridTileProductCount: `${CATALOGUE_GRID_TILE_CUSTOM_COMPONENT_PREFIX}-product-count`
};

export const SHADOW_DOM_DEFAULT_FONT = `
  a, abbr, address, article, aside, audio,
  b, blockquote, body, button,
  canvas, caption, cite, code,
  details, dialog, div, dt,
  em, embed,
  fieldset, figcaption, figure, footer, form,
  header, html,
  i, iframe, img, input,
  label, legend, li,
  main,
  nav,
  ol, optgroup, option,
  pre,
  section, select, span, strong, sub, sup,
  table, tbody, td, textarea, tfoot, th, thead, time, tr,
  ul,
  video {
    font-family: var(--default-font);
  }

  input::-webkit-input-placeholder,
  input:-moz-placeholder,
  input::-moz-placeholder,
  input:-ms-input-placeholder,
  input::-ms-input-placeholder {
    font-family: var(--default-font);
  }

  h1 {
    font-family: var(--heading-font);
  }

  h2, h3, h4, h5, h6 {
    font-family: var(--sub-heading-font);
  }

  p {
    font-family: var(--paragraph-font);
  }

  .gjs-css-rules, .gjs-js-cont {
    opacity: 0 !important;
    visibility: hidden !important;
    display: none !important;
    height: 0px !important;
    min-height: 0px !important;
    max-height: 0px !important;
    width: 0px !important;
    min-width: 0px !important;
    max-width: 0px !important;
    position: fixed !important;
    top: -10000px !important;
    left: -10000px !important;
    z-index: -10000 !important;
  }
`;

const geocodePincodePromises = {};

export const getUserAgent = () => {
  const queryParameters = new URLSearchParams(window.location.search);
  const userAgentOverride = queryParameters.get('userAgentOverride');
  if (
    typeof userAgentOverride === 'string' &&
    userAgentOverride.length > 0 &&
    userAgentOverride !== navigator.userAgent
  ) {
    return userAgentOverride;
  }
  return navigator.userAgent;
};

const mobile = getUserAgent().match(/(iPad)|(iPhone)|(iPod)|(android)|(webOS)/i);
const ios = /iPad|iPhone|iPod/.test(getUserAgent()) && !window.MSStream;
const android = getUserAgent().match(/(android)/i);
const safari = /^((?!chrome|android).)*safari/i.test(getUserAgent());

export const appendHttps = (url) => {
  if (STARTS_WITH_WWW.test(url)) {
    return `https://${url}`;
  }
  return url;
};

export const getAssetPath = (asset) => `${cdnHost}assets/${asset}`;

export const getImageId = (url = '') =>
  url.substring(url.lastIndexOf('/') + 1, url.lastIndexOf('.'));

export const getSmallImageSources = (url, options) => {
  if (!url) {
    return [];
  }

  const sources = [];

  const sizes = [20, 50, 100, 200, 400];

  const startAt = options && options.startAt ? options.startAt : 20;
  const endAt = options && options.endAt ? options.endAt : 400;

  let ext;
  let imageId;
  let temp;
  let productId;
  try {
    ext = url.slice(url.lastIndexOf('.') + 1);
    imageId = url.slice(url.lastIndexOf('/') + 1, url.lastIndexOf('.'));
    temp = url.slice(0, url.lastIndexOf('products') - 1);
    productId = temp.slice(temp.lastIndexOf('/') + 1);
  } catch (ex) {
    return [];
  }

  sizes.slice(sizes.indexOf(startAt), sizes.indexOf(endAt) + 1).forEach((size) => {
    try {
      const endPath = `${productId}/products_${size}/${imageId}.${ext}`;

      const cloudfrontUrl = `${s3ImagesCdnEndpoint}/${endPath}`;
      const s3url = `${s3ImagesEndpoint}/${endPath}`;

      if (!includes(getUserAgent(), 'UCBrowser')) {
        sources.push(cloudfrontUrl);
      }

      sources.push(s3url);
    } catch (ex) {
      //
    }
  });

  return sources;
};

export const getLargeImageSources = (url) => {
  if (!url) {
    return [];
  }

  const sources = [];

  let ext;
  let imageId;
  let temp;
  let productId;
  let endPath;
  try {
    ext = url.slice(url.lastIndexOf('.') + 1);
    imageId = url.slice(url.lastIndexOf('/') + 1, url.lastIndexOf('.'));
    temp = url.slice(0, url.lastIndexOf('products') - 1);
    productId = temp.slice(temp.lastIndexOf('/') + 1);

    endPath = `${productId}/products/${imageId}.${ext}`;
  } catch (ex) {
    return [];
  }

  const cloudfrontUrl = `${s3ImagesCdnEndpoint}/${endPath}`;

  if (!includes(getUserAgent(), 'UCBrowser')) {
    sources.push(cloudfrontUrl);
  }
  sources.push(url);

  return sources;
};

export const isIOS = () => ios;

export const getRootDomain = () => {
  if (process.env.NODE_ENV === 'development' || includes(location.host, 'localhost')) {
    return 'localhost';
  }

  const parts = location.host.split('.').reverse();

  if (parts.length === 1) {
    return `.${parts[0]}`;
  }

  return `.${parts[1]}.${parts[0]}`;
};

export const openUrlWithFallback = (url1, url2) => {
  window.location.href = url1;

  const fallbackTimer = setTimeout(() => {
    window.location.href = url2;
  }, 1000);

  window.addEventListener('blur', () => {
    window.clearTimeout(fallbackTimer);
  });
};

export const getCssGradientPrefix = () => {
  let prefix = '';

  const prefixes = ['-o-', '-ms-', '-moz-', '-webkit-'];

  let dom = document.createElement('div');

  for (let i = 0; i < prefixes.length; i += 1) {
    dom.style.background = `${prefixes[i]}linear-gradient(#000000, #ffffff)`;

    if (dom.style.background) {
      prefix = prefixes[i];
    }
  }

  dom = null;

  return prefix;
};

export const getFormattedAddress = (address) => {
  if (!address) {
    return null;
  }

  return [
    address.addressLineOne,
    address.addressLineTwo,
    [address.city, address.pincode].filter((part) => !!part).join(' - '),
    address.state,
    address.country
  ]
    .filter((part) => !!part)
    .join(', ');
};

export const isMobile = () => mobile;

export const isAndroid = () => android;

export const isSafari = () => safari;

export const isEmail = (email) => {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

export const isIphone = () =>
  navigator.maxTouchPoints > 0 &&
  !/iPad/.test(getUserAgent()) &&
  /iPhone/.test(getUserAgent()) &&
  !/Macintosh/.test(getUserAgent()) &&
  !/AppleWatch/.test(getUserAgent()) &&
  !/AppleTV/.test(getUserAgent());

export const isIpad = () =>
  navigator.maxTouchPoints > 0 &&
  /iPad/.test(getUserAgent()) &&
  !/iPhone/.test(getUserAgent()) &&
  !/Macintosh/.test(getUserAgent()) &&
  !/AppleWatch/.test(getUserAgent()) &&
  !/AppleTV/.test(getUserAgent());

export const hexToRGBValues = (hex) => {
  const rawHex = hex[0] === '#' ? hex.slice(1) : hex;
  let rHex = null;
  let gHex = null;
  let bHex = null;
  if (rawHex.length === 3) {
    rHex = `${rawHex[0]}${rawHex[0]}`;
    gHex = `${rawHex[1]}${rawHex[1]}`;
    bHex = `${rawHex[2]}${rawHex[2]}`;
  } else {
    rHex = `${rawHex[0]}${rawHex[1]}`;
    gHex = `${rawHex[2]}${rawHex[3]}`;
    bHex = `${rawHex[4]}${rawHex[5]}`;
  }

  return [parseInt(rHex, 16), parseInt(gHex, 16), parseInt(bHex, 16)];
};

export const getImageSourcesForSize = (url, size) => {
  let ext;
  let imageId;
  let temp;
  let productId;
  let endPath;
  try {
    ext = url.slice(url.lastIndexOf('.') + 1);
    imageId = url.slice(url.lastIndexOf('/') + 1, url.lastIndexOf('.'));
    temp = url.slice(0, url.lastIndexOf('products') - 1);
    productId = temp.slice(temp.lastIndexOf('/') + 1);

    if (size) {
      endPath = `${productId}/products_${size}/${imageId}.${ext}`;
    } else {
      endPath = `${productId}/products/${imageId}.${ext}`;
    }
  } catch (ex) {
    return [url];
  }

  const cloudfrontUrl = `${s3ImagesCdnEndpoint}/${endPath}`;

  const sources = [];
  if (shouldLoadCloudfront() && getUserAgent().indexOf('UCBrowser') === -1) {
    sources.push(cloudfrontUrl);
  }

  sources.push(url);

  // Note: removing potential duplicates from here, because server has started sending only cloudfront urls
  // In case if s3 links are getting constructed, then replaced with cdn url, need to remove that duplicate
  return [...new Set(sources)];
};

// eslint-disable-next-line prefer-regex-literals
export const linebreak = (input) => (input || '').replace(new RegExp('\\n', 'g'), '<br/>');

export const geocodePincode = (pincode, country) => {
  if (geocodePincodePromises[`${pincode}_${country}`]) {
    return geocodePincodePromises[`${pincode}_${country}`];
  }

  geocodePincodePromises[`${pincode}_${country}`] = new Promise((resolve) => {
    apiGeocodePincode(pincode, country)
      .then((geo) => {
        resolve(geo);
        if (!geo) {
          delete geocodePincodePromises[`${pincode}_${country}`];
        }
      })
      .catch(() => {
        resolve(null);
        delete geocodePincodePromises[`${pincode}_${country}`];
      });
  });

  return geocodePincodePromises[`${pincode}_${country}`];
};

export const parsePhone = (phone) => {
  if (!phone) {
    return {};
  }
  const countries = getCountries();

  for (let i = 0; i < countries.length; i += 1) {
    const callingCode = countries[i].callingCode.replace(/ /g, '');

    if (phone.indexOf(callingCode) === 0) {
      return { callingCode, number: phone.slice(callingCode.length) };
    }
  }

  return {};
};

export const isCanvasSupported = (() => {
  const elem = document.createElement('canvas');
  return !!(elem.getContext && elem.getContext('2d'));
})();

export const getTwoDigitDecimal = (amount) => Math.round(amount * 100) / 100;

export const arrayToBgColor = ({ rgbValues = [] }) =>
  rgbValues.map((values) => `rgb(${values.join(',')})`);

export const redirectToErrorPage = (logErrorToConsole) => {
  if (logErrorToConsole) {
    console.error(logErrorToConsole);
  }

  window.location.href = '/s/error';
};

export const redirectToGalleryView = (productId, options = {}) => {
  const { overwrite } = options;
  const slug = getShowcaseSlug();

  if (!slug || !productId) {
    logException("Can't redirect to gallery view, slug or productId is missing", {
      slug,
      productId,
      options
    });
    redirectToErrorPage();
    return;
  }

  route(`/s/gallery/${slug}/product/${productId}`, !!overwrite);
};

export const redirectToHomeGrid = ({ replace = false } = {}) => {
  const slug = getShowcaseSlug();

  if (!slug) {
    logException("Can't redirect to home grid, slug is missing", { slug });
    redirectToErrorPage();
    return;
  }

  route(`/s/${slug}`, replace);
};

export const getImageWidth = (layoutType) => {
  if (layoutType === HOME_LAYOUT_TYPE.MAGAZINE) {
    // -30 for horizontal padding
    return Math.min(window.innerWidth - 30, 500);
  } else if (layoutType === HOME_LAYOUT_TYPE.LIST) {
    return 96;
  }
};

export const backgroundColorIsWhite = (rgbValue) =>
  rgbValue ? rgbValue.reduce((acc, curVal) => acc && curVal > 220, true) : false;

export const calculateTax = ({ couponPrice, discountedPrice, originalPrice, taxes }) => {
  let price = null;

  if (price === null && typeof couponPrice !== 'undefined') {
    price = couponPrice;
  }

  if (price === null && typeof discountedPrice !== 'undefined') {
    price = discountedPrice;
  }

  if (price === null && typeof originalPrice !== 'undefined') {
    price = originalPrice;
  }

  let { taxPercentage } = taxes[0];
  taxPercentage = Number(taxPercentage);

  return price ? price * (taxPercentage / 100) : 0;
};

const getItemWidth = () => {
  const windowWidth = window.innerWidth;
  // percent
  let itemWidth = 50;
  if (windowWidth >= 1025) {
    itemWidth = 20;
  } else if (windowWidth >= 769) {
    itemWidth = 30;
  } else if (windowWidth >= 668) {
    itemWidth = 33.3;
  }

  return itemWidth;
};

export const getItemsPerRow = () => Math.floor(100 / getItemWidth());

export const getItemsDimension = (parentPadding = 0, containerPadding = 0) => {
  const windowWidth = window.innerWidth;
  const itemWidth = getItemWidth();
  return (
    (itemWidth / 100) *
    (windowWidth - parentPadding - containerPadding * Math.round(100 / itemWidth))
  );
};

export const isSearchResultView = () => getStoredSearchTerm() || getReturnUrl();

export const getStoredSearchTerm = () => window.searchTerm;

export const getReturnUrl = () => {
  if (location.href.indexOf(RETURN_URI) > -1) {
    const returnUri = new URL(location.href).searchParams.get(RETURN_URI);
    return decodeURIComponent(returnUri);
  }
  return null;
};

export const getSearchTermFromUrl = () => {
  const locationSearch = location.search;
  if (locationSearch) {
    const queriedParam = queryString.parse(locationSearch);
    return queriedParam[SEARCH_TERM];
  }
  return null;
};

export const setSearchTermGlobally = (searchTerm) => {
  window.searchTerm = searchTerm;
};

export const inputContainsOnlyWhiteSpaces = (input) => !input.replace(/\s/g, '').length;

export const getPictures = ({ productId }) => {
  const product = getProduct(productId);
  if (!product) {
    return [];
  }
  const pictureIds = Object.keys(product.pictures);
  if (pictureIds.length === 0) {
    return [];
  }
  pictureIds.sort(
    (a, b) =>
      (product.pictures[a].position || undefined) - (product.pictures[b].position || undefined)
  );
  if (product.default_picture_id) {
    const pos = pictureIds.indexOf(product.default_picture_id);

    if (pos !== -1) {
      pictureIds.splice(pos, 1);
      pictureIds.unshift(product.default_picture_id);
    }
  }

  return pictureIds.map((pictureId) => ({
    url: product.pictures[pictureId].url || null,
    imageId: pictureId,
    height: product.pictures[pictureId].height,
    width: product.pictures[pictureId].width
  }));
};

export const getAspectRatioBasedOnRowProducts = (productIds = [], fromCustomPage) => {
  const aspectRatios = [];
  let aspectRatio = 1 / 1.1;
  productIds.forEach((productId) => {
    const product = getProduct(productId, fromCustomPage);
    if (!product) {
      return;
    }

    const { pictures } = product;
    let { default_picture_id: defaultPictureId } = product;

    if (!defaultPictureId && pictures && Object.keys(pictures).length) {
      defaultPictureId = Object.keys(pictures)[0];
    }

    const picture = pictures[defaultPictureId];

    if (picture && picture.width && picture.height) {
      aspectRatio = (picture.width / picture.height).toFixed(2);
    }

    aspectRatios.push(aspectRatio);
  });

  return Math.min(...aspectRatios);
};

export const logException = (err, metadata = {}) => {
  if (!bugsnagApiKey) {
    return;
  }

  if (err && window.Bugsnag && typeof window.Bugsnag.notify === 'function') {
    try {
      if (!metadata) {
        metadata = {};
      }
      if (!metadata.companyId) {
        metadata.companyId = getCompanyId();
      }
      window.Bugsnag.notify(err, (event) => {
        event.addMetadata('extra', metadata);
      });
    } catch (ex) {
      // handling exception
    }
  }
};

export const detectSwipe = (elementId, callbackFunc) => {
  const ele = document.getElementById(elementId);
  if (!ele) {
    return;
  }

  let direction = '';
  const swipeDet = {
    sX: 0,
    sY: 0,
    eX: 0,
    eY: 0
  };

  // min x swipe for horizontal swipe
  const minX = 30;
  // max x difference for vertical swipe
  const maxX = 30;
  // min y swipe for vertical swipe
  const minY = 30;
  // max y difference for horizontal swipe
  const maxY = 30;

  ele.addEventListener(
    'touchstart',
    (e) => {
      const t = e.touches[0];
      swipeDet.sX = t.screenX;
      swipeDet.sY = t.screenY;
    },
    false
  );
  ele.addEventListener(
    'touchmove',
    (e) => {
      const t = e.touches[0];
      swipeDet.eX = t.screenX;
      swipeDet.eY = t.screenY;
    },
    false
  );
  ele.addEventListener(
    'touchend',
    (e) => {
      // horizontal detection
      if (
        (swipeDet.eX - minX > swipeDet.sX || swipeDet.eX + minX < swipeDet.sX) &&
        swipeDet.eY < swipeDet.sY + maxY &&
        swipeDet.sY > swipeDet.eY - maxY &&
        swipeDet.eX > 0
      ) {
        if (swipeDet.eX > swipeDet.sX) direction = 'right';
        else direction = 'left';
      } else if (
        /* vertical detection */
        (swipeDet.eY - minY > swipeDet.sY || swipeDet.eY + minY < swipeDet.sY) &&
        swipeDet.eX < swipeDet.sX + maxX &&
        swipeDet.sX > swipeDet.eX - maxX &&
        swipeDet.eY > 0
      ) {
        if (swipeDet.eY > swipeDet.sY) direction = 'down';
        else direction = 'up';
      }

      if (direction !== '') {
        if (typeof callbackFunc === 'function') {
          callbackFunc(direction);
        }
      }
      direction = '';
      swipeDet.sX = 0;
      swipeDet.sY = 0;
      swipeDet.eX = 0;
      swipeDet.eY = 0;
    },
    false
  );
};

const getCurrentProductInProductList = (productId) => {
  let id = productId;
  const product = getProduct(productId);
  if (product && product.parentProductId) {
    const parentProduct = getProduct(product.parentProductId);
    if (parentProduct) {
      id = parentProduct.defaultVariantId;
    }
  }

  return getCatalogueProductList()[id];
};

export const getNextListOfProducts = (productId) => {
  const productList = getCatalogueProductList();
  const currentProductPosition = getCurrentProductInProductList(productId);
  const sortedProductArray = [];

  /* convert object of products to array (already sorted based on key) */
  if (Object.keys(productList).length > 0) {
    for (const key in productList) {
      if (Object.prototype.hasOwnProperty.call(productList, key)) {
        sortedProductArray.push(key);
      }
    }
  }

  /* If catalogue has just 1 product, return empty */
  if (sortedProductArray.length === 1) {
    return [];
  }

  const productIds = [];

  /* Iterate from next product to end of array (only if next product exists */
  if (sortedProductArray[currentProductPosition + 1]) {
    for (let m = currentProductPosition + 1; m < sortedProductArray.length; m++) {
      productIds.push(sortedProductArray[m]);
      if (productIds.length === MORE_PRODUCTS_COUNT) {
        return productIds;
      }
    }
  }

  /* Iterate from 0 to previous product */
  for (let m = 0; m < currentProductPosition; m++) {
    productIds.push(sortedProductArray[m]);
    if (productIds.length === MORE_PRODUCTS_COUNT) {
      return productIds;
    }
  }

  return productIds;
};

export const isElementVisibleInViewport = (elem, holder) => {
  if (!elem || !holder) {
    return false;
  }

  holder = holder || document.body;
  const { left, right, width } = elem.getBoundingClientRect();
  const holderRect = holder.getBoundingClientRect();

  return left <= holderRect.left
    ? holderRect.left - left <= width
    : right - holderRect.right <= width;
};

export const disableBodyScroll = () => {
  document.body.style.overflow = 'hidden'; // prevent scroll on background while scrolling modal
};

export const enableBodyScroll = () => {
  document.body.style.overflow = 'auto';
};

export const isSizeGuidModalVisible = () => location.href.indexOf(SIZE_GUIDE_HASH) !== -1;

export const isResellerBundleView = (fromBundle) => fromBundle === BUNDLE_VIEW.RESELLER;

export const isValidNumber = (numToCheck) => {
  if (
    !(typeof numToCheck === 'number' || typeof numToCheck === 'string') ||
    (typeof numToCheck === 'string' && numToCheck.trim() === '')
  ) {
    return false;
  }

  const num = Number(numToCheck);
  return !Number.isNaN(num);
};

export const getTransformedCssValue = (defaultValue) => {
  if (!defaultValue || defaultValue === 'none') {
    return defaultValue;
  }

  const prefixes = ['-o-', '-ms-', '-moz-', '-webkit-'];
  for (let m = 0; m < prefixes.length; m++) {
    if (includes(defaultValue, prefixes[m])) {
      return defaultValue;
    }
  }

  let prefixValue = cache.getCssPrefixValue();
  if (prefixValue) {
    return prefixValue + defaultValue;
  }

  // Create a temporary DOM object for testing
  let dom = document.createElement('div');

  for (let i = 0; i < prefixes.length; i++) {
    // Attempt to set the style
    dom.style.background = prefixes[i] + 'linear-gradient(#000000, #ffffff)';

    // Detect if the style was successfully set
    if (dom.style.background) {
      prefixValue = prefixes[i];
    }
  }

  dom = null;
  cache.setCssPrefixValue(prefixValue);

  return prefixValue + defaultValue;
};

export const getProductIdsWhoseDataDoesNotExists = (productIds) => {
  const productsDataToBeFetched = [];
  productIds.forEach((productId) => {
    if (!getProduct(productId)) {
      productsDataToBeFetched.push(productId);
    }
  });
  return productsDataToBeFetched;
};

const componentToHex = (c) => {
  const hex = c.toString(16);
  return hex.length === 1 ? '0' + hex : hex;
};

export const rgbToHex = (r, g, b) =>
  '#' + componentToHex(r) + componentToHex(g) + componentToHex(b);

export const rgbaToIntensities = (rgbaString) => {
  if (typeof rgbaString !== 'string') {
    return;
  }

  return rgbaString
    .substring(rgbaString.indexOf('(') + 1, rgbaString.indexOf(')'))
    .split(',')
    .map((strVal) => {
      try {
        return Number(strVal);
      } catch (err) {
        return NaN;
      }
    });
};

export const hexToRgb = (hex) => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? `rgb(${parseInt(result[1], 16)}, ${parseInt(result[2], 16)}, ${parseInt(result[3], 16)})`
    : null;
};

export const hexToRgba = (hex, opacity) => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? `rgba(${parseInt(result[1], 16)}, ${parseInt(result[2], 16)}, ${parseInt(
      result[3],
      16
    )}, ${opacity})`
    : null;
};

export const rgbToRgba = (rgb, alpha = 1) => {
  // eslint-disable-next-line prefer-regex-literals
  const [, red, green, blue] = new RegExp(/(\d+),\s*(\d+),\s*(\d+)/).exec(rgb);
  return `rgba(${red}, ${green}, ${blue}, ${alpha})`;
};

export const isLightColor = (hexColor = '#ffffff') => {
  const [r, g, b] = hexToRGBValues(hexColor);
  const hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));
  return hsp > 127.1;
};

export const lightenOrDarkenColor = (color, percent) => {
  let R = parseInt(color.substring(1, 3), 16);
  let G = parseInt(color.substring(3, 5), 16);
  let B = parseInt(color.substring(5, 7), 16);

  R = parseInt((R * (100 + percent)) / 100, 10);
  G = parseInt((G * (100 + percent)) / 100, 10);
  B = parseInt((B * (100 + percent)) / 100, 10);

  R = R < 255 ? R : 255;
  G = G < 255 ? G : 255;
  B = B < 255 ? B : 255;

  const RR = R.toString(16).length === 1 ? `0${R.toString(16)}` : R.toString(16);
  const GG = G.toString(16).length === 1 ? `0${G.toString(16)}` : G.toString(16);
  const BB = B.toString(16).length === 1 ? `0${B.toString(16)}` : B.toString(16);

  return `#${RR}${GG}${BB}`;
};

export const getColorContrastBetweenRgb = ({ rgb1, rgb2 }) => {
  // https://stackoverflow.com/questions/9733288/how-to-programmatically-calculate-the-contrast-ratio-between-two-colors
  const lum1 = getColorLuminanceForRbg({ r: rgb1[0], g: rgb1[1], b: rgb1[2] });
  const lum2 = getColorLuminanceForRbg({ r: rgb2[0], g: rgb2[1], b: rgb2[2] });
  const brightest = Math.max(lum1, lum2);
  const darkest = Math.min(lum1, lum2);
  return (brightest + 0.05) / (darkest + 0.05);
};

export const getColorLuminanceForRbg = ({ r, g, b }) => {
  const a = [r, g, b].map((v) => {
    v /= 255;
    return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
  });
  return a[0] * 0.2126 + a[1] * 0.7152 + a[2] * 0.0722;
};

export const getPrimaryLoaderStyle = (size = '3px') => {
  const primaryColor =
    ((getCatalogueTheme() || {}).addToCartButton || {}).backgroundColor || '#3833EA';

  return {
    border: `solid ${size} ${hexToRgba(primaryColor, 0.2)}`,
    borderLeft: `solid ${size} ${primaryColor}`
  };
};

export const stripNumberOfPlusIfExists = (phone) => {
  if (typeof phone !== 'string') {
    return phone;
  }

  if (phone.charAt(0) !== '+') {
    return phone;
  }

  return phone.slice(1);
};

export const getErrorFieldsForBillingDetails = ({ invalidFieldsError, fromBundle }) => {
  let invalidNameError = invalidFieldsError.NAME;
  let invalidPhoneError = invalidFieldsError.PHONE;
  let invalidEmailError = invalidFieldsError.EMAIL;
  let nameFieldName = 'NAME';
  let phoneFieldName = 'PHONE';
  let emailFieldName = 'EMAIL';
  if (isResellerBundleView(fromBundle)) {
    invalidNameError = invalidFieldsError.CUSTOMER_NAME;
    invalidPhoneError = invalidFieldsError.CUSTOMER_PHONE;
    invalidEmailError = invalidFieldsError.CUSTOMER_EMAIL;
    nameFieldName = 'CUSTOMER_NAME';
    phoneFieldName = 'CUSTOMER_PHONE';
    emailFieldName = 'CUSTOMER_EMAIL';
  }

  return {
    invalidNameError,
    invalidPhoneError,
    invalidEmailError,
    nameFieldName,
    phoneFieldName,
    emailFieldName
  };
};

export const getScrolledPositionKey = (route) => `scrolled_position_${route}`;

export const savedPositionsForKeys = () => getLocalStorage(SAVED_SCROLLED_POSITIONS_KEY);

export const updatePositionKeys = ({ addKey, removeKey }) => {
  let savedPositionsKeys = getLocalStorage(SAVED_SCROLLED_POSITIONS_KEY);

  if (!savedPositionsKeys) {
    savedPositionsKeys = [];
  }

  if (removeKey || addKey) {
    savedPositionsKeys = savedPositionsKeys.filter((key) => key !== removeKey && key !== addKey);
  }

  if (addKey) {
    savedPositionsKeys.push(addKey);
  }

  if (!savedPositionsKeys || !savedPositionsKeys.length) {
    return;
  }

  putLocalStorage(SAVED_SCROLLED_POSITIONS_KEY, savedPositionsKeys);
};

export const clearSavedScrolledPositions = () => {
  const savedPositionKeys = savedPositionsForKeys();
  if (!Array.isArray(savedPositionKeys) || !savedPositionKeys.length) {
    return;
  }
  savedPositionKeys.forEach((key) => deleteLocalStorage(key));
  deleteLocalStorage(SAVED_SCROLLED_POSITIONS_KEY);
};

export const saveScrollPosition = (scrollElement, key) => {
  putLocalStorage(
    key,
    (scrollElement || {}).scrollTop ||
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0
  );
};

export const scrollToSavedPosition = (scrollElement, key) => {
  const savedReviewPosition = getLocalStorage(key);
  if (savedReviewPosition) {
    const yCoordinate = Math.floor(savedReviewPosition);
    if (scrollElement) {
      scrollElement.scrollTo(0, yCoordinate);
    } else {
      window.scrollTo(0, yCoordinate);
    }
  }
  deleteLocalStorage(key);
};

export const getSavedScrollPosition = (key) => {
  updatePositionKeys({ addKey: key });
  return getLocalStorage(key);
};

export const setScrollPosition = (key, position) => {
  updatePositionKeys({ removeKey: key });
  putLocalStorage(key, position);
};

export const attachEventListenerToElement = ({ eventName, listener }) => {
  let cleanup;
  return ({ element, unsubscribe }) => {
    if (typeof cleanup === 'function') {
      cleanup();
    }

    if (unsubscribe) {
      return;
    }

    element = element || window;
    cleanup = () => {
      element.removeEventListener(eventName, listener);
    };
    element.addEventListener(eventName, listener);
  };
};

export const isNavigatingToCurrentLink = (linkUrl) => {
  if (linkUrl) {
    try {
      return new URL(linkUrl).href === location.href;
    } catch (error) {
      return linkUrl === location.pathname;
    }
  }
  return false;
};

export const shouldProcessClick = (event = {}) => {
  if (
    event.ctrlKey ||
    event.shiftKey ||
    event.metaKey || // apple
    (event.button && event.button === 1) // middle click, >IE9 + everyone else
  ) {
    return false;
  }

  return true;
};

export const getPictureFromSelectedImage = ({ product, selectedImageId }) => {
  if (!product || !selectedImageId) {
    return '';
  }

  const { pictures } = product;
  if (!pictures || !pictures[selectedImageId]) {
    logException(new Error('Selected image not present in pictures'), {
      imageId: selectedImageId,
      productId: product.id
    });
    return {};
  }

  return pictures[selectedImageId];
};

export const parseAndValidateNumber = (
  numVal,
  { negataive = false, decimal = false, numDecimals = null, blankStringValid = false } = {}
) => {
  let stringNum = numVal;
  if (typeof numVal !== 'string') {
    if (typeof numVal !== 'number') {
      return null;
    }
    stringNum = numVal.toString();
  }

  if (blankStringValid && stringNum.trim() === '') {
    return '';
  }

  let truncateRegExString = '^';
  let validateRegExString = '^';
  if (negataive) {
    truncateRegExString += '-?';
    validateRegExString += '-?';
  }
  // Create two capturing groups for truncate string
  // this will remove decimals beyond two decimals and will also remove leading zeros
  truncateRegExString += '(0*)?(\\d*';
  validateRegExString += '\\d*';

  if (decimal) {
    // Allow the decimal pattern to repeat at most two times
    // this ensures that if user puts a decimal in the position before the current position
    // then the values can be truncated accordingly
    validateRegExString += '(?:\\.\\d*){0,2}';
    truncateRegExString += '(?:\\.\\d';
    let numRepeats = '*';
    if (typeof numDecimals === 'number') {
      numRepeats = `{0,${numDecimals}}`;
    }

    truncateRegExString += `${numRepeats})?`;
  }

  truncateRegExString += ')';
  validateRegExString += '$';

  const validateNumRegex = new RegExp(validateRegExString);
  const validateMatchResult = stringNum.match(validateNumRegex);
  if (!Array.isArray(validateMatchResult) || validateMatchResult.length === 0) {
    return null;
  }

  const truncateNumRegex = new RegExp(truncateRegExString);
  const matchResult = stringNum.match(truncateNumRegex);

  // Match result should always match here because the validate regex is a superset of the match regex
  if (!Array.isArray(matchResult) || matchResult.length === 0) {
    console.warn('unexpected number validation error');
    return null;
  }

  let parsedNum = matchResult[2] || '';

  // leading zeroes
  const zeroGroup = matchResult[1];

  if (zeroGroup) {
    // No number apart from 0, assing it for the result
    if (!parsedNum) {
      parsedNum = '0';
    }

    // First charcter is a . and 0 exists, add a leading 0 to match user input
    if (parsedNum.charAt(0) === '.') {
      parsedNum = `0${parsedNum}`;
    }
  }

  // . is the only character in the string, add a leading 0
  if (parsedNum.indexOf('.') === parsedNum.length - 1 && parsedNum.length === 1) {
    parsedNum = `0${parsedNum}`;
  }

  return parsedNum || null;
};

export const getCatalogueProductTileActionButtonFont = ({ homeLayoutType }) => {
  if (homeLayoutType === HOME_LAYOUT_TYPE.MAGAZINE) {
    return { size: 16, weight: 600 };
  }

  return { size: 14, weight: 400 };
};

export const encodeReturnUriForSearch = (uri) => encodeURIComponent(uri);

export const getMaximumHeightForProductMedias = ({ productId }) => {
  let maxHeightPicture = 0;
  const product = getProduct(productId);
  if (!product) {
    return 0;
  }

  const { pictures } = product;
  const pictureIds = Object.keys(pictures);
  pictureIds.forEach((pictureId) => {
    const picture = pictures[pictureId];
    if (picture && picture.width && picture.height) {
      const aspectRatio = picture.width / picture.height;
      const height =
        picture.width > window.innerWidth ? window.innerWidth / aspectRatio : picture.height;
      if (height > maxHeightPicture) {
        maxHeightPicture = height;
      }
    }
  });

  return maxHeightPicture;
};

export const getAverageAspectRatioForCatalogueProducts = ({ productIds = [] } = {}) => {
  const catalogueProductIds = productIds || Object.keys(getCatalogueProductList());

  let totalAspectRatio = 0;
  let totalAvailableImagesCount = 0;
  catalogueProductIds.forEach((productId) => {
    const product = getProduct(productId);
    if (!product) {
      return;
    }

    const { pictures } = product;
    const pictureIds = Object.keys(pictures);
    pictureIds.forEach((pictureId) => {
      const picture = pictures[pictureId];
      if (picture && picture.width && picture.height) {
        totalAspectRatio += picture.width / picture.height;
        totalAvailableImagesCount += 1;
      }
    });
  });

  if (totalAvailableImagesCount <= 0) {
    return 1;
  }

  return totalAspectRatio / totalAvailableImagesCount;
};

export const shouldShowLockIcon = (accessLevel) => accessLevel === 'PRIVATE';

export const getWindowsAvailableWidth = () => window.innerWidth;

export const isDesktopView = () => getWindowsAvailableWidth() > 768;

export const isElementXPercentInViewport = (element, percentVisible) => {
  if (!element) {
    return false;
  }
  const rect = element.getBoundingClientRect();
  const windowHeight = window.innerHeight || document.documentElement.clientHeight;
  return !(
    Math.floor(100 - ((rect.top >= 0 ? 0 : rect.top) / +-rect.height) * 100) < percentVisible ||
    Math.floor(100 - ((rect.bottom - windowHeight) / rect.height) * 100) < percentVisible
  );
};

export const showAlert = (message) => {
  // eslint-disable-next-line no-alert
  window.alert(message);
};

export const formatDate = (date) =>
  new Date(date).toLocaleDateString(undefined, { dateStyle: 'long' });

export const isStringValidForSeoTag = (value) => {
  if (
    !value ||
    typeof value !== 'string' ||
    value.length === 0 ||
    inputContainsOnlyWhiteSpaces(value)
  ) {
    return false;
  }
  // check whether there are any emoji characters in the product name/description
  // emojis are not allowed in the seo tag as per google schema tag documentation
  return !(
    /\p{Extended_Pictographic}/gu.test(value) ||
    /([\uE000-\uF8FF]|\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDDFF])/.test(value) ||
    /\ud83c[\udf00-\udfff]|\ud83d[\udc00-\ude4f]|\ud83d[\ude80-\udeff]/.test(value) ||
    /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/.test(
      value
    )
  );
};

export const isAppRunningLocallyOrRootDomain = () => {
  const { hostname } = window.location;
  return (
    [
      'localhost',
      'dev.quicksell.co',
      'dev-2.quicksell.co',
      'dev-3.quicksell.co',
      'quicksell.co'
    ].indexOf(hostname) > -1 ||
    hostname.endsWith('.dev.quicksell.co') ||
    hostname.endsWith('.dev-2.quicksell.co') ||
    hostname.endsWith('.dev-3.quicksell.co')
  );
};
